import * as types from './actionTypes';

export function clearAlert(alertId) {
    return function (dispatch) {
        dispatch({
            type: types.CLEAR_ALERT,
            payload: alertId,
        });
    };
}
export function addAlert(alert) {
    return function (dispatch) {
        dispatch({
            type: types.FIRE_ALERT,
            payload: alert,
        });
        if (alert.type === 'success') setTimeout(() => { dispatch(clearAlert(alert.id)); }, 5000);
        if (alert.type === 'info') setTimeout(() => { dispatch(clearAlert(alert.id)); }, 15000);
    };
}
